import BaseLink from '@components/common/atoms/BaseLink';
import BaseSocialMediaLink from '@components/common/atoms/BaseSocialMediaLink';
import ContactSupportTwoToneIcon from '@mui/icons-material/ContactSupportTwoTone';
import InfoTwoToneIcon from '@mui/icons-material/InfoTwoTone';
import InstagramIcon from '@mui/icons-material/Instagram';
import ShareTwoToneIcon from '@mui/icons-material/ShareTwoTone';
import { Box, Grid, Typography } from '@mui/material';
import React from 'react';

interface FooterProps {
}

const Footer: React.FC<FooterProps> = ({ }) => {
    return (
        <Grid
            p={2}
            pt={4}
            mt={{ xs: 4, md: 8 }}
            container
            bgcolor={"#f7f7f7"}
            width={"100%"}
            borderTop={"1px solid #e9e9e9"}
            direction={"column"}
            justifyContent={{ xs: "flex-start", md: "center" }}
            alignItems={{ xs: "flex-start", md: "center" }}>
            <Box
                display={"grid"}
                justifyContent={"flex-start"}
                width={"auto"}
                gap={{ xs: 4, md: 18 }}
                sx={{
                    gridTemplateColumns: { xs: "repeat(1, 1fr) !important", sm: "repeat(1, 1fr) !important", md: "repeat(3, 1fr) !important", lg: "repeat(3, 1fr) !important" }
                }}>
                <Box display={"flex"} flexDirection={"column"}>
                    <Box display={"flex"} gap={1}>
                        <InfoTwoToneIcon color='secondary' />
                        <Typography
                            color={"secondary"}
                            mb={1}
                            fontWeight={600}>
                            Informacije
                        </Typography>
                    </Box>

                    <Box display={"flex"} flexDirection={"column"} gap={1}>
                        <BaseLink
                            route='/about-us'
                            title='O nama'
                            variant='subtitle2'
                            color={"text.primary"}
                            underline='hover' />

                        <BaseLink
                            route='/our-offer'
                            title='Što nudimo?'
                            variant='subtitle2'
                            color={"text.primary"}
                            underline='hover' />
                    </Box>
                </Box>

                <Box display={"flex"} flexDirection={"column"}>
                    <Box display={"flex"} gap={1}>
                        <ContactSupportTwoToneIcon color='secondary' />
                        <Typography
                            color='secondary'
                            mb={1}
                            fontWeight={600}>
                            Kontakt
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant='caption' fontWeight={600}>Korisnička podrška</Typography>
                        <Typography variant='subtitle2'>support@narucko.com</Typography>
                    </Box>

                    <Box mt={1}>
                        <Typography variant='caption' fontWeight={600}>Partner</Typography>
                        <Typography variant='subtitle2'>partner@narucko.com</Typography>
                    </Box>
                </Box>

                <Box display={"flex"} flexDirection={"column"}>
                    <Box display={"flex"} gap={1}>
                        <ShareTwoToneIcon color='secondary' />
                        <Typography
                            color='secondary'
                            mb={1}
                            fontWeight={600}>
                            Prati nas
                        </Typography>
                    </Box>

                    <BaseSocialMediaLink link='https://www.instagram.com/narucko_bh/' icon={<InstagramIcon />} />
                </Box>

            </Box>

            <Box mt={6} display={"flex"} width={"100%"} justifyContent={"center"} alignItems={"center"}>
                <Typography variant='caption' textAlign={"center"} color={"text.secondary"}>©2024 Naručko. Sva prava pridržana</Typography>
            </Box>
        </Grid>
    )
}

export default Footer;